<template>
  <b-card border-variant="light" class="shadow2 mb-3" id="cardBanner">
    <b-card-text v-if="pCardBannersValues.banners.length > 0">
      <swiper :options="swiperOption">
        <swiper-slide v-for="banner in pCardBannersValues.banners" :key="banner.url" class="bannerMiddle"> <!--@click.native="selecionarCores(index)"-->
          <img :src="banner.url" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </b-card-text>
    <b-card-text v-else>
      <span><img src="@/assets/sem-banner.jpg" alt="" /></span>
    </b-card-text>
  </b-card>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import catalogoService from '@/services/tableCatalogo'
export default {
  props: {
    pCardBannersValues: {
      banners: []
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      banners: [],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    pCardBannersValues: function (newVal, oldVal) { // watch it
      this.banners = newVal
    }
  },
  created () {
  }
}
</script>
<style scoped>
#cardBanner {
  max-height: 350px;
}
#cardBanner img {
  max-width: 100%;
  max-height: 310px;
}
.bannerMiddle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/items/cardBannersVue.vue